<template>
  <a
    v-tooltip="tooltip"
    :href="viewFullDayUrl"
    title="View full day"
    target="_blank"
    class="d-inline-flex align-items-center insights-view-full-day-link gap-5"
    @click="trackClick"
  >
    <slot />
    <i class="hi hi-external"></i>
  </a>
</template>
<script>
import { parseInternalDatetime } from '~/utils/time_utils';

export default {
  name: 'InsightsViewFullDayLink',
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    event: {
      type: String,
      default: 'SN view day',
    },
    timeZone: {
      type: String,
      default: 'user',
    },
  },
  computed: {
    viewFullDayUrl() {
      const timeZone = this.timeZone ? this.timeZone : '';
      const date = parseInternalDatetime(this.date).format('YYYY-MM-DD');

      return `/organizations/${this.organizationId}/activities?date=${date}&filters[user]=${this.userId}&time_zone=${encodeURIComponent(timeZone)}`;
    },
    tooltip() {
      // disable tooltip if text present
      return !this.$slots.default;
    },
  },
  methods: {
    trackClick() {
      window.analytics?.track(this.event);
    },
  },
};
</script>
